import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuizFindAnswerMutation } from '@/store/usersApi';
import { tg } from '@/constants/telegram';
import { isQuizNotCompletedError, notifyQuizNotCompleted } from '@/shared/utils';

export const useRequiredReviewsCheck = () => {
  const [shouldShowTestimonials, setShouldShowTestimonials] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [quizFindAnswer] = useQuizFindAnswerMutation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkRequiredReviews = async () => {
      // Проверяем, что мы находимся на странице /trains
      if (location.pathname !== '/trains') {
        setShouldShowTestimonials(false);
        setIsLoading(false);
        return;
      }

      if (!tg?.initData) {
        setIsLoading(false);
        return;
      }

      try {
        const result = await quizFindAnswer({
          data_type: ['required_reviews']
        }).unwrap();

        // Если required_reviews равен null, перенаправляем на страницу отзывов
        const shouldShow = result.answers?.required_reviews === null;
        if (shouldShow) {
          navigate('/testimonials');
        }
        setShouldShowTestimonials(false);
      } catch (error) {
        if (isQuizNotCompletedError(error)) {
          notifyQuizNotCompleted();
          navigate("/quiz");
        } else {
          console.error('Ошибка при проверке обязательных отзывов:', error);
        }
        setShouldShowTestimonials(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkRequiredReviews();
  }, [quizFindAnswer, location.pathname, navigate]);

  return {
    shouldShowTestimonials,
    isLoading
  };
};
